// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__ULAl9","right":"styles_right__VNIo7"};